@if (!wasVisibleAtLeastOnce) {
  <div sis-enter-viewport-notifier (visibilityChange)="setMapVisibility($event)"></div>
}
<ion-grid id="asset-content">
  <ion-row>
    <ion-col [size]="openSidepane && bigScreenMode ? 9 : 12">
      @if (layers && wasVisibleAtLeastOnce) {
        <div
          leaflet
          #leafletContainer
          cdkDropList
          (cdkDropListDropped)="drop($event)"
          id="mapList"
          class="sis-pano-map"
          [style.background-color]="backgroundColor"
          [leafletOptions]="options"
          [leafletLayers]="layers"
          (leafletMapReady)="onMapReady($event)"
          [(leafletCenter)]="center"
          [cdkContextMenuTriggerFor]="context_menu"
          [cdkContextMenuDisabled]="!editMode"
        >
          @for (slope of slopes; track trackByGuid($index, slope)) {
            <sis-map-element-container
              [assetsLayerGroup]="assetsLayerGroup"
              [element]="slope"
              [showStatus]="showStatus"
              [showSlopeLabels]="showSlopeLabels"
              [editMode]="editMode"
              data-test="sis-slope-layer-group"
            ></sis-map-element-container>
          }
          @for (trail of trails; track trackByGuid($index, trail)) {
            <sis-map-element-container
              [assetsLayerGroup]="assetsLayerGroup"
              [element]="trail"
              [showStatus]="showStatus"
              [editMode]="editMode"
              data-test="sis-trail-layer-group"
            ></sis-map-element-container>
          }
          @for (lift of lifts; track trackByGuid($index, lift)) {
            <sis-map-element-container
              [assetsLayerGroup]="assetsLayerGroup"
              [element]="lift"
              [showStatus]="showStatus"
              [editMode]="editMode"
              data-test="sis-lift-layer-group"
            ></sis-map-element-container>
          }
          @for (poi of pois; track trackByGuid($index, poi)) {
            <sis-map-element-container
              [assetsLayerGroup]="assetsLayerGroup"
              [element]="poi"
              [showStatus]="showStatus"
              [editMode]="editMode"
              data-test="sis-poi-layer-group"
            ></sis-map-element-container>
          }
          @for (place of places; track trackByGuid($index, place)) {
            <sis-map-element-container
              [assetsLayerGroup]="assetsLayerGroup"
              [element]="place"
              [showStatus]="false"
              [editMode]="editMode"
              data-test="sis-place-layer-group"
            ></sis-map-element-container>
          }
          @for (customIcon of customIcons; track trackByGuid($index, customIcon)) {
            <sis-map-element-container
              [assetsLayerGroup]="assetsLayerGroup"
              [element]="customIcon"
              [showStatus]="false"
              [editMode]="editMode"
              data-test="sis-custom-icon-layer-group"
            ></sis-map-element-container>
          }
          @for (customPath of customPaths; track trackByGuid($index, customPath)) {
            <sis-map-element-container
              [assetsLayerGroup]="assetsLayerGroup"
              [showStatus]="false"
              [element]="customPath"
              [editMode]="editMode"
              data-test="sis-custom-path-layer-group"
            ></sis-map-element-container>
          }
          @for (gastro of gastros; track trackByGuid($index, gastro)) {
            <sis-map-element-container
              [assetsLayerGroup]="assetsLayerGroup"
              [showStatus]="showStatus"
              [element]="gastro"
              [editMode]="editMode"
              data-test="sis-gastro-layer-group"
            >
            </sis-map-element-container>
          }
          @for (webcam of webcams; track trackByGuid($index, webcam)) {
            <sis-map-element-container
              [assetsLayerGroup]="assetsLayerGroup"
              [showStatus]="false"
              [element]="webcam"
              [editMode]="editMode"
              data-test="sis-webcam-layer-group"
            >
            </sis-map-element-container>
          }
          @for (wind of winds; track trackByGuid($index, wind)) {
            <sis-map-element-container
              [assetsLayerGroup]="assetsLayerGroup"
              [element]="wind"
              [showStatus]="false"
              [masterData]="masterData"
              [editMode]="editMode"
              data-test="sis-wind-layer-group"
            >
            </sis-map-element-container>
          }
        </div>
      }
    </ion-col>
    @if (editMode && bigScreenMode) {
      <ion-col [size]="openSidepane ? 3 : 0">
        <div class="sis-open-sidepane-button" (click)="onOpenSidepaneClick()">
          @if (openSidepane) {
            <span>⟫</span>
          } @else {
            <span>⟪</span>
          }
        </div>
        <sis-sismap-sidepane [class.hide-sidepane]="!openSidepane"></sis-sismap-sidepane>
      </ion-col>
    }
  </ion-row>
</ion-grid>
@if (editMode && bigScreenMode) {
  <div class="edit-mode-banner">
    <span>Edit Mode</span>
  </div>
}

@if (enableAssetSidepane) {
  <sis-asset-sidepane [editMode]="editMode" [bigScreenMode]="bigScreenMode"></sis-asset-sidepane>
}

<ng-template #context_menu>
  <div class="context-menu" cdkMenu>
    <button class="context-menu-item" cdkMenuItem (click)="addWebcam()">Neue Webcam</button>
    <button class="context-menu-item" cdkMenuItem (click)="addPlace()">Neuer Place</button>
    <button class="context-menu-item" cdkMenuItem (click)="addCustomIcon()">Neues CustomIcon</button>
    <button class="context-menu-item" cdkMenuItem (click)="addCustomPath()">Neuer CustomPath</button>
  </div>
</ng-template>
